module.exports = __webpack_public_path__ + "static/media/514.5fe6bcd7.png";